import React from 'react';
import { Link } from 'react-router-dom';

import navina from '../../assets/imgs/navina/next_risk.png'; 


const SparkPage = () => {



  return (
              
        <div className='bg-light'>
          <div className='header-height'></div>
                <div className='row'>
                <div className='col-sm-2 col-xs-none'></div>
                <div className='col-sm col-xs-12'>

                  <div className='row px-3 px-sm-5'>
                  <div className='col-md text-start mb-5 '>
                    <p className='fs-2 fw-normal lh-1 capitalize mb-2'>Spark Success-Based Education</p>
                    <p className='fs-1rem fw-light capitalize'>
                    Short 2D animated explainer video
                    </p>
                    <p className='mt-4 fw-light'>2019</p>

                  </div>
                  <div className='col-md'>
                    <p className='fw-normal fs-5'>
                    This 2D animated short was created to illustrate the concept of success-based education, a model where students focus on achievement, motivation, and growth—paying back tuition only after securing a job. Designed as an engaging explainer, the animation helps potential investors and students understand the program’s benefits, emphasizing its innovative approach to accessible, results-driven education.
                                        </p>
                  </div>
          </div>
        </div>


      <div className='px-0 my-5 py-5'>
        <video width="100%" height="auto" controls loop>
          <source src="https://d4eb9hkrm2864.cloudfront.net/portfolio/Spark.mp4" type="video/mp4" />
        </video>
        </div>
      </div>





<div className='row py-5 px-3 px-sm-5'>
<div className='col-sm-2 col-xs-12'></div>
<div className='col-sm col-xs-12'>

<div className='py-2'>
  <h5 className='fs-18 fw-600'>Client: Spark success-based eduction</h5>
</div>


    <div className='py-2'></div>
    <div className='d-block'>
    </div>

    <div className='py-2'></div>


    <div className='row'>
      <div className='col-sm col-xs-12'>
        <h5 className='fs-18 fw-600'>Capabilities</h5>
          <ul className='p-0'>
          <li className='py-1'>Scriptwriting</li>
          <li className='py-1'>Storyboard</li>
            <li className='py-1'>Animation</li>
            <li className='py-1'>Post-production</li>
          </ul>
      </div>
      <div className='col-sm col-xs-12'>
        <h5 className='fs-18 fw-600'>Softwares</h5>
          <ul className='p-0'>
            <li className='py-1'>Illustrator</li>
            <li className='py-1'>After Effect</li>
            <li className='py-1'>Audition</li>
          </ul>
      </div>
      
      <div className='col-sm col-xs-12'>
        <h5 className='fs-18 fw-600'>Cooperation</h5>
          <ul className='p-0'>
            <li className='py-1'>Project</li>

          </ul>
      </div>

      <div className='col-sm col-xs-12'>
        <h5 className='fw-600'>Industry</h5>
            <li className='py-1'>Eduction</li>
            <h5 className='fw-600 pt-2'>Duration</h5>
            <li className='py-1'>1 Months</li>
      </div>
    </div>
</div>
</div>

<div className='row mx-0 mt-3 mt-sm-5'>
  <div className='col-sm-12 col-xs-12 text-end p-5'>
      <Link to={"/navina"}>
        <a className='fs-5 fw-bold text-dark'>
          Next work 
          <div className='arrow-right'></div>
          </a>
            </Link>
        </div>
        <div className='col-sm-2 col-xs-12 p-3 p-sm-5'>

        </div>
          <div className='col-sm col-xs-12 p-0'>
          <Link to={"/navina"}>
            <div className='image-box-300'>
              <img src={navina} alt="prodbo next" />
            </div>
          </Link>
        </div>
      </div>


</div>





  );
};

export default SparkPage;
